import {Injectable} from '@angular/core';
import {StammdatenSteuernummer, Steuernummer} from '@nachdigal';
import {AbstractMapper} from '../../abstract.mapper';

@Injectable()
export class SteuernummerMapperService extends AbstractMapper<StammdatenSteuernummer, Steuernummer> {

  protected mapInternal(source: StammdatenSteuernummer): Steuernummer {

    let steuer = source.steuernummer?.replace(/[^\d]/g, '');
    if (source.finanzamtnummer?.startsWith('26')) {
      steuer = steuer?.substr(1, 10);
    }
    return {
      finanzamtnummer: source.finanzamtnummer,
      steuernummer: steuer
    };
  }
}
